import { ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';
import { environment } from '../environments/environment';
import { AuthService } from './core/services/auth.service';
import { MockAuthService } from './core/services/auth.mock.service';
import { UserService } from './core/services/user.service';
import { MockUserService } from './core/services/mocks/mock.user.service';
import { ExpenseService } from './core/services/expense.service';
import { MockExpenseService } from './core/services/mocks/mock.expense.service';
import { HabitService } from './core/services/habit.service';
import { MockHabitService } from './core/services/mocks/mock.habit.service';
import { TripService } from './core/services/trip.service';
import { MockTripService } from './core/services/mocks/mock.trip.service';
import { FamilyService } from './core/services/family.service';
import { MockFamilyService } from './core/services/mocks/mock.family.service';
import { FeedbackService } from './core/services/feedback.service';
import { MockFeedbackService } from './core/services/mocks/mock.feedback.service';

import { provideAnimations } from '@angular/platform-browser/animations';
import { provideNativeDateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideServiceWorker } from '@angular/service-worker';
import { registerLocaleData } from '@angular/common';
import localeIn from '@angular/common/locales/en-IN';

registerLocaleData(localeIn);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptors([loadingInterceptor])),
    importProvidersFrom(
      MatNativeDateModule,
      MatDatepickerModule
    ),
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    ...(environment.useMockAuth
      ? [
        { provide: AuthService, useClass: MockAuthService },
        { provide: UserService, useClass: MockUserService },
        { provide: ExpenseService, useClass: MockExpenseService },
        { provide: HabitService, useClass: MockHabitService },
        { provide: TripService, useClass: MockTripService },
        { provide: FamilyService, useClass: MockFamilyService },
        { provide: FeedbackService, useClass: MockFeedbackService }
      ]
      : [
        provideAuth(() => getAuth())
      ]),
    provideFirestore(() => getFirestore()),
    provideFunctions(() => getFunctions(undefined, 'asia-south1')),
    provideStorage(() => getStorage()),
    provideMessaging(() => getMessaging()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode() || (typeof window !== 'undefined' && window.location.hostname !== 'localhost'),
      registrationStrategy: 'registerWhenStable:30000'
    })
  ]
};